import { SecurityAccessFeaturesEnum } from 'bff';
import { FeatureToggleRoute } from 'modules/app/components/atoms/feature-flags/useFeature';
import { RouteGuard } from 'components/atoms/route-guard/RouteGuard';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import { ReportPeriod } from 'modules/reports/new-report/report-period/ReportPeriod';
import { ReviewReport } from 'modules/reports/new-report/review/ReviewReport';
import { SelectClients } from 'modules/reports/new-report/select-clients/SelectClients';
import { ReportOverview } from 'modules/reports/overview/ReportOverview';
import { NewReport } from 'modules/reports/NewReport';
import { RouteObject } from 'react-router-dom';
import { routes } from 'routes/route-paths';
import { StepHandle } from 'types/routing/proposal-step-handle';

export const reportRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <FeatureToggleRoute
        component={
          <RouteGuard
            component={<ReportOverview />}
            features={[SecurityAccessFeaturesEnum.Dashboard]}
          />
        }
        fallback={<NotFound />}
        feature='showReports'
      />
    )
  },
  {
    path: routes.reportsRoutes.new,
    handle: {
      breadcrumb: { text: 'New Report' }
    },
    element: (
      <RouteGuard component={<NewReport />} features={[SecurityAccessFeaturesEnum.Dashboard]} />
    ),
    children: [
      {
        path: routes.reportsRoutes.newReportRoutes.selectClients,
        handle: {
          stepNumber: 1
        } satisfies StepHandle,
        element: <SelectClients />
      },
      {
        path: routes.reportsRoutes.newReportRoutes.reportPeriod,
        handle: {
          stepNumber: 2
        } satisfies StepHandle,
        element: <ReportPeriod />
      },
      {
        path: routes.reportsRoutes.newReportRoutes.review,
        handle: {
          stepNumber: 3
        } satisfies StepHandle,
        element: <ReviewReport />
      }
    ]
  }
];
